export const LIBRARY_LIST_PAGE_SIZE = 12;

export const LIBRARY_LIST_TABS = ['my', 'nanumteo', 'favorites'];

export const emptyLibraryList = () => ({
  key: null,
  items: [],
  page: 0,
  hasNext: false,
  totalCount: 0,
});

export const emptyLibraryLists = () => LIBRARY_LIST_TABS.reduce((acc, tab) => {
  acc[tab] = emptyLibraryList();
  return acc;
}, {});

// 내 자료는 유형만 서버 조건이다. 학교급·교과·정렬·검색이 바뀌어도 같은 목록이다.
// viewer가 바뀌면(로그인·로그아웃) 좋아요·즐겨찾기 표시가 달라지므로 다른 목록이다.
export const buildLibraryListKey = ({
  tab,
  typeFilter = 'all',
  schoolLevel = 'all',
  subject = 'all',
  sort = 'latest',
  search = '',
  viewer = '',
}) => {
  if (tab === 'my') return JSON.stringify({ tab, typeFilter, viewer });
  return JSON.stringify({ tab, typeFilter, schoolLevel, subject, sort, search, viewer });
};

export const mergeUniqueById = (base = [], incoming = []) => {
  const seen = new Set(base.map((item) => item?.id));
  const merged = [...base];
  incoming.forEach((item) => {
    if (!item?.id || seen.has(item.id)) return;
    seen.add(item.id);
    merged.push(item);
  });
  return merged;
};

export const applyLibraryListPage = (prevList, {
  key,
  pageNum,
  items = [],
  hasNext = false,
  totalCount = 0,
  sortItems = null,
}) => {
  const appending = pageNum > 1 && prevList?.key === key;
  const base = appending ? prevList.items : [];
  const merged = mergeUniqueById(base, items);
  return {
    key,
    items: sortItems ? sortItems(merged) : merged,
    page: pageNum,
    hasNext: Boolean(hasNext),
    // 나눔터 둘러보기는 1쪽에서만 개수를 센다.
    totalCount: Number(totalCount) || (appending ? prevList.totalCount : 0),
  };
};

// 창으로 돌아왔을 때 1쪽만 다시 받아 기존 목록에 덮어쓴다. 이미 불러온 뒤쪽 카드와 스크롤은 그대로 둔다.
export const refreshLibraryListHead = (prevList, {
  items = [],
  hasNext = false,
  sortItems = null,
}) => {
  const fresh = new Map(items.filter((item) => item?.id).map((item) => [item.id, item]));
  const updated = prevList.items.map((item) => (
    fresh.has(item.id) ? { ...item, ...fresh.get(item.id) } : item
  ));
  const merged = mergeUniqueById(updated, items);
  return {
    ...prevList,
    items: sortItems ? sortItems(merged) : merged,
    hasNext: prevList.page <= 1 ? Boolean(hasNext) : prevList.hasNext,
  };
};

export const patchLibraryListItem = (list, itemId, patch) => {
  if (!list.items.some((item) => item.id === itemId)) return list;
  return {
    ...list,
    items: list.items.map((item) => (
      item.id === itemId
        ? { ...item, ...(typeof patch === 'function' ? patch(item) : patch) }
        : item
    )),
  };
};

export const removeLibraryListItem = (list, itemId) => {
  if (!list.items.some((item) => item.id === itemId)) return list;
  return {
    ...list,
    items: list.items.filter((item) => item.id !== itemId),
    totalCount: list.totalCount > 0 ? list.totalCount - 1 : 0,
  };
};
